/**
 * Shared tile provider config for all Leaflet maps.
 *
 * Uses OpenStreetMap's own tile CDN — free forever, no API key, no watermark.
 * Dark mode is achieved with a CSS filter on the tile layer (see index.css /
 * .map-tiles-dark rule). Cleaner than CARTO's watermarked free tier and
 * requires zero config.
 */

export const OSM_ATTRIBUTION =
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

// Standard OSM tiles — used for both themes; dark mode inverts them via CSS.
export const OSM_TILE_URL = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";

/** Return the tile-layer className that should be applied based on the current theme. */
export const tileClassForTheme = (theme) =>
    theme === "dark" ? "map-tiles-dark" : "map-tiles-light";
